<template>
  <div id="contratos-toolbar-contratos-ejecucion">
    <v-toolbar flat>
      <v-toolbar-title class="display-1">
        {{ titulo }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- BOTON PLANTILLAS -->
      <custom-button
        v-if="!$vuetify.breakpoint.xs"
        class="mr-2"
        label="Plantillas"
        iconText="mdi-file-word-outline"
        tipo="agregar"
        @click="generarNuevaPlantilla"
      >
      </custom-button>
      <!-- BOTON EXCEL REPORTE SUPERVISIÓN -->
      <exportar-excel-reporte-supervision
        v-if="!$vuetify.breakpoint.xs">
      </exportar-excel-reporte-supervision>
    </v-toolbar>
    <v-dialog v-model="mostrarGenerarNuevaPlantilla"
        scrollable
        persistent
        width="800"
        >
          <generar-nueva-plantilla
          modulo="ejecucion"
          :datos="getDatos"
          :idarchivo="titulo"
          ref="generarNuevaPlantilla"
          @cerrarGenerarNuevaPlantilla="cerrarGenerarNuevaPlantilla">
          </generar-nueva-plantilla>
        </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import GenerarNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/Default.vue';
import ExportarExcelReporteSupervision from '@/components/exportar/exceles/ExcelReporteSupervision.vue';
import mixDatosContratos from '@/components/administracion/configuracion/plantillas/generador/mixDatosContratos';

export default {
  name: 'TituloToolBarContratoEjecucion',
  props: {
    partidas: {
      type: Array,
      required: true,
    },
    titulo: {
      type: String,
      required: false,
      default: 'Reportes',
    },
    datos: {
      type: Object,
      required: false,
      default() { return {}; },
    },
    fechas: {
      type: Array,
      required: true,
    },
    mostrarBtnRegresar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ExportarExcelReporteSupervision,
    CustomButton,
    GenerarNuevaPlantilla,
  },
  mixins: [mixDatosContratos],
  data() {
    return {
      mostrarGenerarNuevaPlantilla: false,
    };
  },
  methods: {
    agregarNivelesPartidas() {
      const partidasNivel = new Map();
      this.partidas.forEach((partida) => {
        const nivel = partida.idPadre !== '' ? (partidasNivel.get(partida.idPadre) || 1) + 1 : 1;
        partidasNivel.set(partida.id, nivel);
      });
      return this.partidas.slice().map((partida) => ({
        // ...partida,
        descripcion: `${'\t'.repeat(partidasNivel.get(partida.id) - 1)}${'-'.repeat(partidasNivel.get(partida.id))} ${partida.concepto}`,
      }));
    },
    concatenarPartidas() {
      const partidasNivel = this.agregarNivelesPartidas();
      let resultado = '';
      partidasNivel.forEach((item) => {
        resultado += `\n${item.descripcion}`;
      });
      return resultado;
    },
    generarNuevaPlantilla() {
      this.mostrarGenerarNuevaPlantilla = !this.mostrarGenerarNuevaPlantilla;
    },
    cerrarGenerarNuevaPlantilla() {
      this.generarNuevaPlantilla();
    },

  },
  computed: {
    getDatos() {
      if (!this.datos) return {};
      const datos = {
        ...this.datos,
        contrato_Partidas_lista: this.agregarNivelesPartidas(),
        Partidas: this.concatenarPartidas(),
      };
      return this.formatoWordContrato(datos);
    },
  },
};
</script>

<style lang="scss">

</style>
